import { gql } from "graphql-request";

const SERVER_DELETE_SETTLEMENT = gql`
  mutation SERVER_DeleteSettlement($id: ID!, $userContractId: ID!) {
    deleteSettlement(id: $id, userContractId: $userContractId)
  }
`;
export default SERVER_DELETE_SETTLEMENT;
